import styled from '@emotion/styled'
export const StyledSvg = styled.div<any>`
  display: flex;
  cursor: pointer;
  svg {
    width: 100% !important;
    height: 100% !important;
    fill: ${(props: any) =>
      props.theme.colors[props.fill || 'transparent']} !important;
    color: ${(props: any) =>
      props.theme.colors[props.color] || props.color} !important;
  }
`
